import Moment from 'react-moment'
import { CampaignTypes } from '../Codes'
import { showEditlogDetail } from './editlogSlice'
import Table from '../../components/table/Table'
import PropTypes from 'prop-types'
import { Link, useParams } from 'react-router-dom'
import { useMemo } from 'react'
import { AGGREGATE_TYPES } from './filters/AggregateTypeFilter'
import { BizChannelLink, CreativeLink, RestrictionIpLink } from './EditlogLinks'
import { useDispatch, useSelector } from 'react-redux'
import TrackerName from './TrackerName'
import Button from '../../components/form/Button'
import { isNil } from 'lodash'

const EditlogRow = ({
  id,
  createdTime,
  actorDto,
  aggregate,
  crudActionType,
  hasDetail,
  actions,
  actionsSummary,
}) => {
  const dispatch = useDispatch()
  const { isDetailLoading } = useSelector(state => state.editlog)
  const { accountId } = useParams()
  const aggregateType = useMemo(
    () => AGGREGATE_TYPES.find(t => t.id === aggregate.type)?.name || '',
    [aggregate.type]
  )
  const EditLogName = useMemo(() => {
    const { type, strId, name } = aggregate
    if (isNil(name)) {
      return '-'
    } else if (crudActionType === 'DELETE') {
      return (
        <span className="txt_limit">
          {name}
          <span className="fc_warn">(삭제)</span>
        </span>
      )
    } else if (type === 'ADACCOUNT') {
      return (
        <Link to={`/${accountId}/dashboard`} className="txt_limit fc_emph">
          {name}
        </Link>
      )
    } else if (type === 'CAMPAIGN') {
      return (
        <Link
          to={`/${accountId}/gotoDashboard?campaignId=${strId}`}
          className="txt_limit fc_emph">
          {name}
        </Link>
      )
    } else if (type === 'ADGROUP') {
      return (
        <Link
          to={`/${accountId}/gotoDashboard?adGroupId=${strId}`}
          className="txt_limit fc_emph">
          {name}
        </Link>
      )
    } else if (type === 'KEYWORD') {
      return (
        <Link
          to={`/${accountId}/gotoDashboard?keywordId=${strId}`}
          className="txt_limit fc_emph">
          {name}
        </Link>
      )
    } else if (type === 'CREATIVE_LINK') {
      return (
        <Link
          to={`/${accountId}/gotoDashboard?creativeLinkId=${strId}`}
          className="txt_limit fc_emph">
          {name}
        </Link>
      )
    } else if (type === 'BIZCHANNEL') {
      return <BizChannelLink id={strId} name={name} />
    } else if (type === 'CREATIVE') {
      return <CreativeLink id={strId} name={name} />
    } else if (type === 'RESTRICTION_IP') {
      return <RestrictionIpLink id={strId} name={name} />
    } else {
      return <span className="txt_limit">{name}</span>
    }
  }, [accountId, aggregate, crudActionType])
  const editLogActionSummary = useMemo(() => {
    const [action] = actions
    if (
      actions.length === 1 &&
      action?.type === 'CAMPAIGN_CONVERSION_TRACKING_CHANGE'
    ) {
      return (
        <>
          전환추적 변경(
          <TrackerName id={action.before} />→<TrackerName id={action.after} />)
        </>
      )
    } else {
      return actionsSummary
    }
  }, [actions, actionsSummary])
  return (
    <Table.Row rowId={id}>
      <td>
        <div className="inner_tbl">
          <Moment format="YYYY.MM.DD HH:mm">{createdTime}</Moment>
        </div>
      </td>
      <td>
        <div className="inner_tbl">{actorDto.displayName}</div>
      </td>
      <td>
        <div className="inner_tbl">{aggregateType}</div>
      </td>
      <td>
        <div className="inner_tbl">{EditLogName}</div>
      </td>
      <td>
        <div className="inner_tbl">{editLogActionSummary}</div>
      </td>
      <td className="align_c">
        <div className="inner_tbl">
          <Button
            size="small"
            disabled={
              isDetailLoading ||
              (aggregate.subType !== CampaignTypes.TALK_CHANNEL && !hasDetail)
            }
            onClick={() => {
              dispatch(showEditlogDetail(id))
            }}>
            상세보기
          </Button>
        </div>
      </td>
    </Table.Row>
  )
}
EditlogRow.propTypes = {
  id: PropTypes.string,
  createdTime: PropTypes.string,
  actorDto: PropTypes.shape({
    displayName: PropTypes.string,
  }),
  aggregate: PropTypes.shape({
    type: PropTypes.string,
    subType: PropTypes.string,
    strId: PropTypes.string,
    name: PropTypes.string,
  }),
  crudActionType: PropTypes.string,
  hasDetail: PropTypes.bool,
  actions: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string,
      before: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.object,
        PropTypes.array,
      ]),
      after: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.object,
        PropTypes.array,
      ]),
    })
  ),
  actionsSummary: PropTypes.string,
}
export default EditlogRow
